export default __webpack_public_path__ + "static/media/leviathanscall.105b6d8b.png";